import { render } from "./ChatModals.vue?vue&type=template&id=ba84116c&scoped=true"
import script from "./ChatModals.vue?vue&type=script&lang=js"
export * from "./ChatModals.vue?vue&type=script&lang=js"

import "./ChatModals.vue?vue&type=style&index=0&id=ba84116c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba84116c"]])

export default __exports__